import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'

import { Button, Box, TablePagination, useMediaQuery } from '@material-ui/core'

import { routes } from 'Routes'
import { useHistory } from 'react-router-dom'

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'

import { Permitted, MenuButton, ActiveStatusChip } from 'components'
import { ChangeStatusCategoryButton } from '../CategoryEdit/components'

import constants from 'constants/index'
import theme from 'theme'

const CategoryTable = ({
  categories = [],
  totalCount = 0,
  isLoading = false,
  page = 1,
  perPage = 5,
  onPageChange,
  onRowsPerPageChange,
  refresh,
}) => {
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })
  const history = useHistory()

  const handleEditClick = (category) => {
    history.push(
      routes.complaint.categoryEdit.replace(':categoryId', category.id),
    )
  }

  return (
    <>
      <PerfectScrollbar
        options={{ wheelPropagation: false, useBothWheelAxes: true }}
      >
        <Table
          emptyMessage="Nenhuma categoria encontrada"
          isLoading={isLoading}
        >
          <TableHead>
            <TableRow>
              <TableCell width="25%">Categoria</TableCell>
              <TableCell width="20%">Responsáveis</TableCell>
              <TableCell width="15%" align="center">
                Tipo
              </TableCell>
              <TableCell width="15%" align="center">
                Opções
              </TableCell>
              <TableCell width="15%" align="center">
                Status
              </TableCell>
              <TableCell width="10%" align="center">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {categories.map((category) => (
              <TableRow key={category?.id}>
                <TableCell width="25%">{category?.name}</TableCell>
                <TableCell width="20%">
                  {category.responsibles && category.responsibles.length > 0
                    ? category.responsibles
                        .map((responsible) => responsible.name)
                        .join(', ')
                    : 'Nenhum responsável'}
                </TableCell>
                <TableCell width="15%" align="center">
                  {category.customizable ? 'Customizável' : 'Padrão'}
                </TableCell>
                <TableCell width="10%" align="center">
                  {category.customizable
                    ? 'Indefinido'
                    : category.subCategoriesCount > 0
                    ? category.subCategoriesCount
                    : 'Adicionar'}
                </TableCell>
                <TableCell width="10%" align="center">
                  <ActiveStatusChip active={category.active} />
                </TableCell>
                <TableCell width="25%" align="center">
                  <Permitted
                    someTags={[
                      constants.permissions.COMPLAINTS.MANAGE_CONFIGURATIONS,
                      constants.permissions.COMPLAINTS.ACTIVATE_COMPLAINTS,
                    ]}
                  >
                    <MenuButton>
                      <Button
                        color="secondary"
                        onClick={() => handleEditClick(category)}
                        fullWidth
                        size="small"
                      >
                        Editar
                      </Button>
                      <ChangeStatusCategoryButton
                        category={category}
                        onRefresh={refresh}
                      />
                    </MenuButton>
                  </Permitted>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </PerfectScrollbar>

      {totalCount > 0 && (
        <Box px={2} display="flex" justifyContent="flex-end">
          <TablePagination
            component="div"
            count={totalCount}
            onPageChange={onPageChange}
            onRowsPerPageChange={onRowsPerPageChange}
            page={page - 1}
            rowsPerPage={perPage}
            rowsPerPageOptions={[5, 10, 25, 100]}
            labelRowsPerPage={isDesktop ? 'Por página' : ''}
            nextIconButtonProps={{ size: 'small' }}
            backIconButtonProps={{ size: 'small' }}
          />
        </Box>
      )}
    </>
  )
}

export default CategoryTable
